<template>
  <div class="place">
    <main-content right-sidebar="true"></main-content>
  </div>
</template>
<script>
import MainContent from '@/components/MainContent'
import { mapGetters } from 'vuex'

export default {
  name: 'place',
  
  components: { MainContent }
}
</script>
<style lang="scss">

.place {
  height: 100%;
  left: 0;
  pointer-events: auto;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
